import { useMemo } from 'react'
import moment from 'moment'
import { isBookingWithinDateRange } from 'lib/dateUtils'
import { isLPCTacticalEnabled } from 'lib/offerUtils'
import { useAppSelector } from 'hooks/reduxHooks'
import { isLoggedIn as isLoggedInSelector } from 'selectors/accountSelectors'
import { OFFER_TYPE_ALWAYS_ON } from 'constants/offer'

export function useLPCTacticalSearchTilePromotions(offer: App.Offer | App.OfferSummary, checkinDate?: string, checkoutDate?: string) {
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isAuthorised = isLoggedIn || !offer.walledGarden

  return useMemo(() => {
    let bestPrice: App.Package|undefined
    let shouldShowUpsell = false
    const selectedDuration = checkinDate && checkoutDate ? moment(checkoutDate).diff(moment(checkinDate), 'days') : undefined
    if (isLPCTacticalEnabled() && offer.type === OFFER_TYPE_ALWAYS_ON && (offer?.hasTactical ?? false) && selectedDuration) {
      const tacticalPackages = (offer?.packages ?? []).filter(pkg => (pkg?.hasTactical ?? false) && pkg.price > 0 && selectedDuration <= pkg.duration)
      if (tacticalPackages.length > 0) {
        bestPrice = tacticalPackages[0]
        const tacticalSchedules = bestPrice.roomRate?.schedules.filter(schedule => schedule.type == 'tactical')
        if (tacticalSchedules && tacticalSchedules.length > 0) {
          const travelPeriod = tacticalSchedules[0].travelPeriod
          const withinDateRange = isBookingWithinDateRange(checkinDate, checkoutDate, travelPeriod.from, travelPeriod.to)
          shouldShowUpsell = (selectedDuration ? selectedDuration <= bestPrice.duration : false) && !withinDateRange && isAuthorised
        }
      }
    }

    return {
      bestPrice,
      shouldShowUpsell,
    }
  }, [offer, checkinDate, checkoutDate, isAuthorised])
}
